export default "__VITE_ASSET__4f41147a__"